<p-select 
  [options]="options" 
  [(ngModel)]="_value" 
  (ngModelChange)="_onValueChange($event)"
  [optionLabel]="optionLabel | translate" 
  [optionValue]="optionValue"
  [styleClass]="styleClass"
  class="w-full"
  [placeholder]="placeholder"
  [readonly]="readonly"
/>